import { useCallback, useEffect, useRef } from 'react';
import { useFormLoadObserver } from './useFormLoadObserver';
import { useFormThemeStyles } from './useFormThemeStyles';
import { getFormsDomain, injectScript } from './formScript';
import { jsx as _jsx } from "react/jsx-runtime";
export function VersionTwoForm({
  formId,
  portalId,
  env,
  region,
  dispatch
}) {
  const containerRef = useRef(null);
  const themeStyles = useFormThemeStyles();
  const handleScriptError = useCallback(() => dispatch('onFormLoadError'), [dispatch]);
  useEffect(() => {
    injectScript(`//js.${getFormsDomain(env)}/forms/embed/developer/${portalId}.js`, undefined, handleScriptError);
  }, [portalId, env, handleScriptError]);
  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;
    return () => {
      // Clear embed state so the script treats the container as fresh on re-mount
      delete container.dataset.loaded;
      delete container.dataset.fetched;
      container.innerHTML = '';
    };
  }, [formId, portalId, env]);

  // Signal visual readiness as soon as the SSR fetch completes (data-loaded
  // attribute), so the parent component can show the form. Instance capture
  // happens separately via `hs-form-event:on-ready` (see below).
  const handleLoaded = useCallback(() => dispatch('onFormReady'), [dispatch]);
  useFormLoadObserver(containerRef, handleLoaded, [formId, portalId, env, handleLoaded]);
  useEffect(() => {
    const handleReady = event => {
      const detail = event.detail;
      if (!detail || detail.formId !== formId) return;
      const api = window.HubSpotFormsV4;
      if (!api) return;
      const v4Instance = api.getFormFromEvent(event);
      v4Instance.version = 2;
      dispatch('onFormReady', v4Instance);
    };
    window.addEventListener('hs-form-event:on-ready', handleReady);
    return () => window.removeEventListener('hs-form-event:on-ready', handleReady);
  }, [formId, dispatch]);
  useEffect(() => {
    const handleSubmitted = e => {
      const detail = e.detail;
      if (detail.formId === formId) {
        dispatch('onFormSubmitted');
      }
    };
    window.addEventListener('hs-form-event:on-submission:success', handleSubmitted);
    return () => window.removeEventListener('hs-form-event:on-submission:success', handleSubmitted);
  }, [formId, dispatch]);
  return /*#__PURE__*/_jsx("div", {
    ref: containerRef,
    className: "hs-form-html",
    style: themeStyles,
    "data-form-id": formId,
    "data-portal-id": portalId,
    "data-region": region,
    "data-env": env
  });
}